import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import DatatableComponent from "../../helpers/DatatableComponent";
import React, { useEffect, useState } from "react";
import FormDialog from "../../helpers/FormDialog";
import {
  Box,
  Card,
  Dialog,
  DialogContent,
  Tab,
  Tabs,
} from "@mui/material";
import OpenDocument from "../../helpers/openDocument";
import {getFileMime } from "../../store/helpers/common_functions";
import BasicMenu from "../../helpers/menu";
import DeleteDialog from "../../helpers/DeleteDialog";
import BootstrapDialogTitle from "../../helpers/BootstrapDialogTitle";
import { a11yProps } from "components/Meetings/Meeting";
import { TabPanel } from "components/Meetings/Meeting";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";


function FinanceExpenditure({ SetSelectedMenu, ListAllProjects, projects }) {
  const [count, setCount] = useState(0);
  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [fileView, setFileView] = useState(null);
  const [projectId, setProjectId] = React.useState();
  const [project, setProject] = React.useState({});
  const [tabValue, setTabValue] = useState(0);
  const [description, setDescription] = useState();
  const [openView, setOpenView] = useState(false);
  const [products, setProducts] = useState([]);
  const [product, setProduct] = useState({});
  const [productId, setProductId] = React.useState();
  const [productOpen, setProductOpen] = React.useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const projectList = projects;
  useEffect(() => {
    if (projectId) {
      const selectedProject = projectList?.find(
        (item) => item?.id === projectId
      );
      const pm = selectedProject?.assignee?.find(
        (item) => item.role === "project-manager"
      );

      setProject({ ...selectedProject, pm: pm?.Resource?.names });
    }

    if (productId) {
      const selectedProduct = products?.find((item) => item?.id === productId);
      setProduct(selectedProduct);
    }
  }, [projectId, productId]);

  const fetchProducts = async () => {
    const URL = `/api/product/list`;

    const header = {
      headers: { "access-token": secureLocalStorage.getItem("token") },
    };

    const { data } = await axios.get(URL, header);

    if (data) {
      setProducts(data?.data);
    }
  };

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  useEffect(() => {
    SetSelectedMenu({
      menu: "finance_expenditure",
      title: "Project/Product Expenditures",
    });
    ListAllProjects();
    fetchProducts();
  }, []);

  const types =
    tabValue === 1
      ? [
          {
            label: "Procedure Manuals",
            value: "company",
          },
          {
            label: "PMO Manuals",
            value: "project",
          },

          {
            label: "Developers(best practices)",
            value: "developers",
          },
          {
            label: "DevOps(best practices)",
            value: "devops",
          },
          {
            label: "Technical Manuals",
            value: "technical",
          },
          {
            label: "R&D Manuals",
            value: "r&d",
          },
        ]
      : [
          {
            label: "Completion certificate",
            value: "certificate",
          },
        ];

  const columns = [
    {
      name: tabValue === 0 ? "Project.name" : "Product.name",
      label: tabValue === 0 ? "Project Name" : "Product Name",
    },
    {
      name: "amount",
      label: "Expenditure",
      options: {
        customBodyRender: (v) => v.toLocaleString(),
      },
    },

    {
      name: tabValue === 0 ? "Project.budgetAmount" : "expectedRevenue",
      label: "Project Budget",
      options: {
        customBodyRender: (v) => v.toLocaleString(),
      },
    },
    {
      name: "Project",
      label: tabValue === 0 ? "Expected Revenue" : "Product Revenue",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const amount = tableMeta.rowData[2];
          const budgetAmount = tableMeta.rowData[3];

          return (budgetAmount - amount).toLocaleString();
        },
      },
    },

    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const obj = list[rowIndex];
          return (
            <BasicMenu
              onDelete={() => {
                setDeleteOpen(true);
                setId(obj?.id);
              }}
              onEdit={() => {
                // setOpen(2);
                if (tabValue === 0) {
                  setOpen(2);
                } else {
                  setProductOpen(2);
                }

                setId(obj?.id);
                setValue0("amount", obj.amount ?? 0);
                setValue0("description", obj.description);
                if (tabValue === 0) {
                  setValue0("projectId", obj.projectId);
                  setProjectId(obj.projectId);
                } else {
                  setValue0("productId", obj.productId);
                  setProductId(obj.productId);
                }
              }}
              onDetails={() => {
                setFileView(obj?.attachment);
                setOpenView(true);
                setDescription(obj?.description);
              }}
            />
          );
        },
      },
    },
  ];

  return (
    <div className="w-full mb-12 px-4">
      <div className="">
        <Card className={"overflow-auto mt-3"} variant={"outlined"}>
          <div className={"card-body mt-0 pt-0"}>
            <div className="row group-btn">
              <div className="col-md-7"></div>
            </div>
            <Dialog
              maxWidth={"md"}
              fullWidth={true}
              open={openView}
              onClose={() => setOpenView(false)}
            >
              <BootstrapDialogTitle onClose={() => setOpenView(false)}>
                Document Details
              </BootstrapDialogTitle>
              <DialogContent>
                Description: {description}
                {fileView !== null && (
                  <OpenDocument
                    downloadable={true}
                    document={fileView}
                    name={"supportDocument"}
                    specialName={fileView}
                    type={"permission-doc"}
                    mimeType={getFileMime(fileView)}
                  />
                )}
              </DialogContent>
            </Dialog>
            <DeleteDialog
              url={`/api/expenses/${id}`}
              open={deleteOpen}
              setOpen={setDeleteOpen}
              onSuccess={() => setCount((v) => v + 1)}
              title={"Delete Record"}
            />

            <FormDialog
              onSuccess={() => setCount((v) => v + 1)}
              url={open === 1 ? "/api/expenses/" : `/api/expenses/${id}`}
              fields={[
                {
                  name: tabValue === 0 ? "projectId" : "productId",
                  label: tabValue === 0 ? "Project" : "Product",
                  type: "select",
                  value: tabValue === 0 ? project?.id : product?.id,
                  values:
                    tabValue === 0
                      ? projectList?.map((item) => ({
                          label: item.name,
                          value: item.id,
                        }))
                      : products?.map((item) => ({
                          label: item.name,
                          value: item.id,
                        })),
                  required: true,
                  // hidden: value['type'] !== 'certificate',
                  setValue: tabValue === 0 ? setProjectId : setProductId,
                },
                {
                  name: "client",
                  label: "Client",
                  type: "text",
                  value:
                    tabValue === 0 ? project?.client : product?.productOwner,
                  disabled: true,
                },
                {
                  name: "amount",
                  label: "Total Expenses",
                  type: "number",
                  isNumber: true,
                  value: value["amount"],
                  required: true,
                  setValue: (val) => setValue0("amount", val),
                },
                {
                  name: "attachment",
                  label: "Attachment",
                  type: "file-drag",
                  value: value["attachment"],
                  required: open === 1,
                  setValue: (val) => setValue0("attachment", val),
                },

                {
                  name: "description",
                  label: "Description",
                  type: "textarea",
                  value: value["description"],
                  setValue: (val) => setValue0("description", val),
                },
              ]}
              open={open}
              setOpen={setOpen}
              title={
                open === 1
                  ? tabValue === 1
                    ? "Record Product Expenses"
                    : "Record Project Expenses"
                  : tabValue === 1
                  ? "Update Product Expenses"
                  : "Update Project Expenses"
              }
            />

            <FormDialog
              onSuccess={() => setCount((v) => v + 1)}
              url={productOpen === 1 ? "/api/expenses/" : `/api/expenses/${id}`}
              fields={[
                {
                  name: "productId",
                  label: "Product",
                  type: "select",
                  value: product?.id,
                  values: products?.map((item) => ({
                    label: item.name,
                    value: item.id,
                  })),
                  required: true,
                  // hidden: value['type'] !== 'certificate',
                  setValue: setProductId,
                },
                {
                  name: "client",
                  label: "Client",
                  type: "text",
                  value: product?.productOwner,
                  disabled: true,
                },
                {
                  name: "amount",
                  label: "Total Expenses",
                  type: "number",
                  value: value["amount"],
                  isNumber: true,
                  // required: true,
                  setValue: (val) => setValue0("amount", val),
                },
                {
                  name: "attachment",
                  label: "Attachment",
                  type: "file-drag",
                  value: value["attachment"],
                  // required: open === 1,
                  setValue: (val) => setValue0("attachment", val),
                },

                {
                  name: "description",
                  label: "Description",
                  type: "textarea",
                  value: value["description"],
                  setValue: (val) => setValue0("description", val),
                },
              ]}
              open={productOpen}
              setOpen={setProductOpen}
              title={
                productOpen === 1
                  ? "Record Product Expenses"
                  : "Update Product Expenses"
              }
            />

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={tabValue}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label={"Projects"}
                  iconPosition={"end"}
                  {...a11yProps(0)}
                />

                <Tab label="Products" {...a11yProps(1)} iconPosition={"end"} />
              </Tabs>
            </Box>
            <TabPanel value={tabValue} index={0}>
              <DatatableComponent
                onRowClick={(data, { rowIndex }) => {}}
                onAddNew={() => setOpen(1)}
                processData={(data) => {
                  setList(data.data);

                  return data;
                }}
                elevation={1}
                columns={columns}
                url={`/api/expenses?count=${count}&type=project`}
                title={``}
              />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <DatatableComponent
                onRowClick={(data, { rowIndex }) => {}}
                onAddNew={() => {
                  setProductOpen(1);
                }}
                processData={(data) => {
                  setList(data.data);

                  return data;
                }}
                elevation={1}
                columns={columns}
                url={`/api/expenses?count=${count}&type=product`}
                title={``}
              />
            </TabPanel>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FinanceExpenditure);
